import React from "react";
import ImageUploadLoader from "../Common/Loaders/ImageUploadLoader";
import { blurMessages } from "./constants";

const ImageUploadStep = ({
  formData,
  blurTextIndex,
  stepIndex,
  moveNext,
  handleFileUpload,
  handleDragOver,
  handleDragDrop,
  removeImage,
}) => {
  return (
    <div className="step-panel">
      <div className="step-header">
        <h2>Upload Product Images</h2>
        <p>Add high-quality images of your product</p>
      </div>
      <div
        id="image-upload"
        className="upload-area"
        onDragOver={handleDragOver}
        onDrop={handleDragDrop}
        onClick={() => {
          stepIndex === 0 && moveNext();
          !formData.imageProcessing &&
            document.getElementById("file-input").click();
        }}
      >
        <input
          id="file-input"
          type="file"
          accept="image/*"
          capture="environment"
          multiple
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />
        {formData.imageProcessing ? (
          <ImageUploadLoader
            messages={blurMessages}
            activeIndex={blurTextIndex}
          />
        ) : formData.uploadedImages.length > 0 ? (
          <div className="image-preview-container">
            {formData.uploadedImages.map((img, index) => (
              <div key={index} className="image-preview">
                <img src={img} alt={`Product ${index + 1}`} />
                <span
                  className="image-cross"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeImage(index);
                  }}
                >
                  ×
                </span>
                <span
                  className={`blur-badge ${
                    formData.blurStatuses[index] ? "blurred" : "ok"
                  }`}
                >
                  {formData.blurStatuses[index] ? "Blur!" : "OK"}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="upload-placeholder">
            <div className="upload-icon">📷</div>
            <h3>Drop Images OR Click to Upload</h3>
            <p>JPG, PNG, WebP • Max 5MB</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUploadStep;

